import { wppThemeSetupFromCssUK, wppThemeSetupFromCssUS } from 'services/ThemeSetup';
import { initialPlotVisibility, Localization, plotlyLineColorization } from 'utils';

interface UsePlotlyDataOptimizerProps {
    data: any;
    type: string;
    isNoneCase?: boolean;
    localization?: Localization;
}

export const usePlotlyDataOptimizer = ({
    data,
    type,
    isNoneCase,
    localization,
}: UsePlotlyDataOptimizerProps) => {
    const DEFAULT_LINE_COLOR = '#FFFFFF';
    const DEFAULT_LINE_WIDTH = 1;
    const DEFAULT_NONE_COLOR = '#4D5358';

    if (!data) {
        return null;
    }

    const palette =
        localization === Localization.US ? wppThemeSetupFromCssUS() : wppThemeSetupFromCssUK();

    let uniqueObjArray = [...new Map(data.data.map((item: any) => [item['name'], item])).values()];
    const colorizationMethod = (uniqueArray: any[], palette: any, data: any, name: string) => {
        let readyData: any = [];
        uniqueArray.map((el: any) => {
            const result = data.map((element: any, _?: number, array?: any) =>
                element.name === el.name
                    ? (readyData = [
                          ...readyData,
                          {
                              ...element,
                              test: 'test',
                              isShowing: initialPlotVisibility(element.name),
                              visible: initialPlotVisibility(element.name),
                              line: {
                                  color: plotlyLineColorization(
                                      name,
                                      array,
                                      palette,
                                      element,
                                      DEFAULT_LINE_COLOR,
                                      DEFAULT_LINE_WIDTH,
                                      DEFAULT_NONE_COLOR,
                                      isNoneCase,
                                  ).color,
                                  width: plotlyLineColorization(
                                      name,
                                      array,
                                      palette,
                                      element,
                                      DEFAULT_LINE_COLOR,
                                      DEFAULT_LINE_WIDTH,
                                      DEFAULT_NONE_COLOR,
                                      isNoneCase,
                                  ).width,
                              },
                              fillcolor: palette[element.name],
                              ...((element.type === 'bar' || element.type === 'scatter') && {
                                  marker: {
                                      color: palette[element.name],
                                      size: element.marker?.size || 1,
                                      line: {
                                          color: DEFAULT_LINE_COLOR,
                                          width: element.marker?.line?.width || DEFAULT_LINE_WIDTH,
                                      },
                                  },
                              }),
                          },
                      ])
                    : element,
            );
            return result;
        });

        return readyData;
    };

    const layoutFontRename = JSON.parse(
        JSON.stringify(data.layout).replaceAll('family', 'fontFamily'),
    );

    const colorizedData = colorizationMethod(uniqueObjArray, palette, data.data, type);

    const result = {
        ...data,
        layout: {
            ...layoutFontRename,
        },
        data: colorizedData,
    };
    return result;
};
